/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { clearMembershipCallback } from "../../utils/membershipCallback";

// Cart/direct-order changes mean the user changed their mind — drop the saved
// callback. clearLines/clearDirectOrder are excluded: those fire on the way
// into Checkout, where the callback still needs to be readable.
const CART_DEVIATION_ACTIONS = new Set([
  "cart/addLine",
  "cart/removeLine",
  "cart/resetCart",
  "directOrder/setDirectOrder",
  "directOrder/cancelDirectOrder",
]);

export const membershipCallbackMiddleware = () => (next) => (action) => {
  const result = next(action);
  if (CART_DEVIATION_ACTIONS.has(action.type)) {
    clearMembershipCallback();
  }
  return result;
};
